var _rect, _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundGmSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.13574,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#181B1A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.636,
    r: 14.5,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2030_2517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 31,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.63574C8.21573 1.63574 1.5 8.35147 1.5 16.6357C1.5 24.92 8.21573 31.6357 16.5 31.6357C24.7843 31.6357 31.5 24.92 31.5 16.6357C31.5 8.35147 24.7843 1.63574 16.5 1.63574Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2030_2517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9214 20.216L21.4452 22.765C21.3916 22.8204 21.3268 22.8646 21.2547 22.8948C21.1825 22.9251 21.1047 22.9407 21.026 22.9407H9.28771C9.23172 22.9407 9.17696 22.9251 9.13012 22.8956C9.08329 22.8661 9.04642 22.8242 9.02403 22.775C9.00164 22.7257 8.99469 22.6712 9.00405 22.6182C9.0134 22.5653 9.03864 22.516 9.0767 22.4766L11.5501 19.9276C11.6037 19.8722 11.6685 19.828 11.7406 19.7978C11.8128 19.7676 11.8906 19.7519 11.9694 19.7518H23.7076C23.764 19.7507 23.8197 19.7656 23.8674 19.7948C23.915 19.824 23.9527 19.8659 23.9755 19.9156C23.9984 19.9652 24.0054 20.0202 23.9958 20.0737C23.9862 20.1271 23.9602 20.1767 23.9214 20.216ZM21.4452 15.0818C21.3915 15.0267 21.3265 14.9827 21.2545 14.9524C21.1824 14.9222 21.1046 14.9065 21.026 14.906H9.28771C9.23172 14.9061 9.17696 14.9218 9.13012 14.9512C9.08329 14.9806 9.04642 15.0226 9.02403 15.0719C9.00164 15.1211 8.99469 15.1756 9.00405 15.2286C9.0134 15.2816 9.03864 15.3308 9.0767 15.3702L11.5501 17.9206C11.6039 17.9757 11.6688 18.0197 11.7408 18.0499C11.813 18.0801 11.8907 18.0959 11.9694 18.0963H23.7076C23.7635 18.096 23.818 18.0801 23.8647 18.0506C23.9114 18.021 23.948 17.9791 23.9702 17.9299C23.9924 17.8807 23.9993 17.8263 23.9898 17.7735C23.9804 17.7206 23.9552 17.6715 23.9172 17.6321L21.4452 15.0818ZM9.28771 13.2505H21.026C21.1047 13.2505 21.1825 13.2348 21.2547 13.2045C21.3268 13.1743 21.3916 13.1301 21.4452 13.0748L23.9214 10.5258C23.9602 10.4864 23.9862 10.4368 23.9958 10.3834C24.0054 10.3299 23.9984 10.275 23.9755 10.2253C23.9527 10.1757 23.915 10.1337 23.8674 10.1045C23.8197 10.0754 23.764 10.0605 23.7076 10.0616H11.9694C11.8906 10.0617 11.8128 10.0773 11.7406 10.1075C11.6685 10.1378 11.6037 10.1819 11.5501 10.2373L9.0767 12.7864C9.03864 12.8257 9.0134 12.875 9.00405 12.928C8.99469 12.981 9.00164 13.0354 9.02403 13.0847C9.04642 13.1339 9.08329 13.1759 9.13012 13.2054C9.17696 13.2348 9.23172 13.2505 9.28771 13.2505Z",
    fill: "url(#paint0_linear_2030_2517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2030_2517",
    x1: 10.2659,
    y1: 23.248,
    x2: 22.0156,
    y2: 9.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundGmSol);
export default __webpack_public_path__ + "static/media/roundGmSOL.225ad73a7bb7a1dd073b54648d7c0d08.svg";
export { ForwardRef as ReactComponent };